import { cellToBoundary, cellToLatLng } from "h3-js";

export function hexCellsToFeatureCollections(cells, { resolution, boundaryForCell = cellToBoundary, centerForCell = cellToLatLng } = {}) {
  const polygons = [];
  const centers = [];
  cells.forEach((cell) => {
    const properties = hexFeatureProperties(cell, resolution);
    const boundary = boundaryForCell(cell.h3Index, true);
    const [latitude, longitude] = centerForCell(cell.h3Index);
    polygons.push({
      type: "Feature",
      id: cell.h3Index,
      geometry: { type: "Polygon", coordinates: [closeRing(boundary)] },
      properties,
    });
    centers.push({
      type: "Feature",
      id: `center:${cell.h3Index}`,
      geometry: { type: "Point", coordinates: [longitude, latitude] },
      properties,
    });
  });
  return {
    polygons: { type: "FeatureCollection", features: polygons },
    centers: { type: "FeatureCollection", features: centers },
  };
}

export function hexFeatureProperties(cell, resolution) {
  return {
    h3Index: cell.h3Index,
    totalCount: cell.totalCount,
    sickCount: cell.sickCount,
    resolution,
  };
}

function closeRing(boundary) {
  const ring = boundary.map(([longitude, latitude]) => [longitude, latitude]);
  const first = ring[0];
  const last = ring.at(-1);
  if (first && last && (first[0] !== last[0] || first[1] !== last[1])) ring.push([...first]);
  return ring;
}
